import {Box} from '@mui/material';
import styles from '../../../styles/components/clientdetails/projectDrawerStyle.module.scss';
import AurIcon, {
  IconColors,
  IconNames,
  IconSize,
} from '../../common/aur-icon/AurIcon';

export interface WorkspaceStatusCellProps {
  iconType?: 'Active' | 'Warning' | 'Inactive';
  iconSize?: IconSize;
  cellText: string;
}

const WorkspaceStatusCell: React.FC<WorkspaceStatusCellProps> = ({
  iconType = 'Active',
  iconSize = 'small',
  cellText,
}) => {
  const iconColor: IconColors = (() => {
    switch (iconType) {
      case 'Active':
        return IconColors.Success;
      case 'Inactive':
        return IconColors.Critical;
      case 'Warning':
        return IconColors.Warning;
      default:
        return IconColors.Success;
    }
  })();

  return (
    <Box className={`${styles.workspaceTableStatusCell}`}>
      <AurIcon icon={IconNames.Circle} color={iconColor} size={iconSize} />
      <span>{cellText}</span>
    </Box>
  );
};

export default WorkspaceStatusCell;
